module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/banner/intro-video-x264-1000k-8889fa1ee3e4c36b4f6c02a1f3e33d42.mp4";